import {
    useEffect,
    useEffectEvent,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {useProducts} from '../hooks/useProducts';
import {Product} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";

export const ProductsAutocomplete = ({
                                         field: {
                                             name,
                                             value: fieldValue,
                                         },
                                         form: {setFieldValue},
                                         ...rest
                                     }: FieldProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {items: records, fetchRecords} = useProducts();

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const fetchOnMount = useEffectEvent(() => fetchRecords());

    useEffect(() => {
        fetchOnMount();
    }, []);

    const nameCount = records.reduce((acc: Record<string, number>, record: Product) => {
        const n = record.name || '';
        acc[n] = (acc[n] || 0) + 1;
        return acc;
    }, {});

    const data = records.map((record: Product) => {
        const label = record.name || '';
        const displayValue = nameCount[label] > 1 ? `${label} (${record.id})` : label;
        return {
            ...record,
            label: displayValue,
            value: displayValue,
        };
    });

    const syncWithRecords = useEffectEvent(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const found = records.find((item: Product) => item.id === fieldValue);
        if (typeof found !== 'undefined' && Object.prototype.hasOwnProperty.call(found, 'name')) {
            const label = found.name || '';
            setValue(nameCount[label] > 1 ? `${label} (${found.id})` : label);
        }
    });

    useEffect(() => {
        syncWithRecords();
    }, [records.length]);

    const handleChange = (value: string) => {
        if (!Array.isArray(data)) {
            throw new Error('Data is expected to be an array');
        }
        const found = data.find((item) => item.value === value);

        if (found) {
            setFieldValue(name, found.id);
        }

        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Component'
            {...rest}
        />
    );
};
